import { render } from "./AdminBriefHome.vue?vue&type=template&id=33bff446"
import script from "./AdminBriefHome.vue?vue&type=script&lang=js"
export * from "./AdminBriefHome.vue?vue&type=script&lang=js"
/* custom blocks */
import block0 from "./AdminBriefHome.i18n.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Ftmp%2Fbuild_b2e3e009%2Fpackages%2Fstore%2Fsrc%2Fviews%2Fadmin%2Fanalytics%2FAdminBriefHome.vue&external"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__